<template>
  <el-form ref="ff" :model="detail" label-width="80px">
    <el-form-item label="上级部门" required>
      <el-cascader
        v-model="detail.ParentId"
        :options="deptOptions"
        :props="{
          value: 'Id',
          label: 'Name',
          checkStrictly: true,
          emitPath: false,
        }"
        clearable
        style="width: 100%"
      />
    </el-form-item>
    <el-form-item label="部门名称" prop="Name" required>
      <el-input v-model="detail.Name"></el-input>
    </el-form-item>
    <el-form-item label="序号" prop="Sort">
      <el-input v-model="detail.Sort"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    return {
      deptOptions: [],
      detail: this._detail || {},
    }
  },
  props: {
    _detail: {
      type: Object,
      default: null
    },
    layerid: {
      type: String,
      default: null
    }
  },
  created () {
    this.$apis.organize.dept.list().then(res => {
      this.deptOptions = res
    })
  },
  methods: {
    //提交数据
    onSubmit () {
      this.$refs["ff"].validate(valid => {
        if (valid) {
          this.$apis.organize.dept.submit(this.detail).then(() => {
            this.$layer.close(this.layerid)
            this.$parent.loadData()
            this.$message({ message: "数据提交成功！", type: "success" })
          }).catch(e => {
            this.$message.console.error(e || "数据提交失败！")
          })
        }
      })
    }
  }
};
</script>
